var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary text-uppercase font-weight-bold px-4 py-2 mr-md-3 mb-4 btn__rounded d-lg-none",on:{"click":_vm.openFilter}},[_vm._v("\n    Filter\n")])}
var staticRenderFns = []

export { render, staticRenderFns }